import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './DataPrivacy.css'
import ExpandableCard from '../components/ExpandableCard';
import { useTranslation } from 'react-i18next';
import useLanguagePrefix from '../LanguagePrefix';

function DataPrivacy() {
    const { t } = useTranslation();
    const langPrefix = useLanguagePrefix();
    const [searchTerm, setSearchTerm] = useState("");

    const roomPlanningExpandableCards = [
        { title: t("Centralized Dashboard"), content: t("Manage reservations, availability, and guest data in one place.") },
        { title: t("Housekeeping & Task Management"), content: t("Manage reservations, availability, and guest data in one place.") },
        { title: t("Channel Manager"), content: t("Manage reservations, availability, and guest data in one place.") },
        { title: t("Guest Communication"), content: t("Manage reservations, availability, and guest data in one place.") },
        { title: t("Booking Engine"), content: t("Manage reservations, availability, and guest data in one place.") },
        { title: t("Revenue Management"), content: t("Manage reservations, availability, and guest data in one place.") },
        { title: t("Property Management System"), content: t("Manage reservations, availability, and guest data in one place.") },
        { title: t("Housekeeping Scheduling"), content: t("Manage reservations, availability, and guest data in one place.") }
    ];

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    return (
        <div>
            <Helmet>
                <title>Prostay – Data Privacy | How We Protect Your Data</title>
                <meta name="description" content="Read how Prostay protects your privacy and processes your data in compliance with GDPR, CCPA, and global regulations." />
                <link rel="canonical" href={"https://www.prostay.com" + langPrefix + "/data-privacy/"} />

                <link rel="alternate" href="https://www.prostay.com/en/data-privacy/" />
                <link rel="alternate" href="https://www.prostay.com/es/data-privacy/" />

                <meta property="og:title" content="Prostay – Data Privacy | How We Protect Your Data" />
                <meta property="og:description" content="Read how Prostay protects your privacy and processes your data in compliance with GDPR, CCPA, and global regulations." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={"https://www.prostay.com" + langPrefix + "/data-privacy/"} />
                <meta property="og:image" content='https://prostay.com/images/ogImage.png' />

                <meta property="og:site_name" content="Prostay" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Prostay – Data Privacy | How We Protect Your Data" />
                <meta name="twitter:description" content="Read how Prostay protects your privacy and processes your data in compliance with GDPR, CCPA, and global regulations." />
                <meta name="twitter:image" content='https://prostay.com/images/ogImage.png' />
                <meta name="twitter:site" content="@prostaypms" />
                <meta name="twitter:creator" content="@prostaypms" />
            </Helmet>
            <div className='data-privacy'>
                <div className='background-image'>
                    <div className='background-image-start'>
                        <div className='mt-2 d-flex align-items-center gap-1 breadcrumbs'>
                            <a href={`${langPrefix}/`} style={{ textDecoration: "none", display: 'flex' }}><span style={{ cursor: 'pointer' }}>{t('Home')}</span></a>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.66797 5.33337L9.33464 8.00004L6.66797 10.6667" stroke="#606576" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <span style={{ color: "#1643E0" }} >{t('Data Privacy')}</span>
                        </div>
                        <div className='mt-2'>
                            <h1>
                                {t('Data Privacy')}
                            </h1>
                        </div>
                    </div>
                </div>
                <div className='border-margin'>
                    <div className='custom-container'>
                        <p>At Prostay, your data privacy and security are our highest priority.
                            <br />
                            We are committed to protecting the personal and business information of every property, guest, and user on our platform.
                        </p>
                        <h5>Secure by Design</h5>
                        <p>Prostay is built with modern data security practices at its core. We use robust encryption, secure authentication methods, and role-based access control to protect all sensitive data.</p>
                        <h6>Trusted Infrastructure</h6>
                        <p>We’ve partnered with Microsoft Azure for data hosting and infrastructure security. This ensures that your data is stored in world-class data centers with advanced protection, including:</p>
                        <ul>
                            <li>Physical and network security</li>
                            <li>Geo-redundant backups</li>
                            <li>Real-time threat monitoring</li>
                            <li>Compliance with international standards (GDPR, ISO 27001, etc.)</li>
                        </ul>
                        <h5>Your Data, Your Control</h5>
                        <p>We believe in transparency and control. As a Prostay user, you:</p>
                        <ul>
                            <li>Own all the data you input into the system</li>
                            <li>Can request data export or deletion at any time</li>
                            <li>Have visibility into who accesses your data and why</li>
                        </ul>
                        <h5>Compliance & Data Handling</h5>
                        <p>Prostay follows industry best practices and complies with global privacy laws. Our systems are designed to respect guest privacy, minimize data retention, and ensure responsible processing of personal information.</p>
                        <h5>Responsible Access</h5>
                        <p>Only authorized users can access your account data, and all access is tracked and logged. We also provide customizable user permissions to help properties control access internally.</p>
                        <h5>Questions or Concerns?</h5>
                        <p>If you have any questions about our data privacy policies, please contact our team at office@prostay.com</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DataPrivacy;
